import React from "react";
import {useTranslation} from "react-i18next";
import {InformationTooltip} from "../shared-components/InformationTooltip";

export const LogicalToggleField = ({
                                       id,
                                       name,
                                       value,
                                       onChange,
                                       disableDescriptions,
                                       customMessageFalse,
                                       customMessageTrue,
                                       containerStyle,
                                       info}) => {
    const {t} = useTranslation();

    const renderLabel = () => {
        if (!name) return;
        return (
            <label htmlFor={id} className={'form-label'}>
                {info && <InformationTooltip text={info}/>}
                <span>{name}</span>
            </label>
        );
    }

    const renderDescriptions = () => {
        if (disableDescriptions) return;
        if (!customMessageTrue || !customMessageFalse) {
            return value ? t('visibleInMenu') : t('invisibleInMenu');
        }
        return value ? customMessageTrue : customMessageFalse;
    }

    return (
        <div className={'form-field-wrapper'}>
            <div className={'form-field-container'} style={containerStyle}>
                {renderLabel()}
                <div className={'flex-centered'}>
                    <div className="toggle-switch">
                        <input type="checkbox"
                               id={id}
                               name={id}
                               value={value}
                               onChange={onChange}
                               checked={value}/>
                        <label htmlFor={id} className="toggle-label"></label>
                    </div>
                    <span className={'menu-visibility-msg'}>
                    {renderDescriptions()}
                </span>
                </div>
            </div>
        </div>
    );
}